/**
 * @function getInitials A function that returns the first letters from the firstName and lastName of the user
 * @param {string} firstName firstName of the user, can be obtained via the user object
 * @param {string} lastName lastName of the user, can be obtained via the user object
 * @return {string} Concatenation of the first letter from the first name and the last name
 */
export const getInitials = (firstName: string, lastName: string) => {
    return (firstName.charAt(0) + lastName.charAt(0)).toUpperCase();
};
